/**
 * Dragon type annotations for the Dossier kingdom header.
 *
 * IMPORTANT: These are display-only annotations. DragonSystem.java is currently a stub
 * with no offense hook (returns 1.0 for income only). The Dossier does NOT apply any
 * dragon offense modifier to Modified Offense — this was an iter-1 mistake, regression
 * test in dragonAnnotations.test.ts guards against re-introducing an offense modifier.
 *
 * If a future SF adds dragon combat hooks to DragonSystem, the Dossier will pick them
 * up automatically via MilitaryMath — this file must NOT be the source of that change.
 */

export interface DragonAnnotation {
  label: string;
  economicEffect: string;
}

/** Dragon type → display annotation. No offense modifier is returned or applied. */
const DRAGON_ANNOTATIONS: Record<string, DragonAnnotation> = {
  NONE: {
    label: 'No Dragon',
    economicEffect: 'No dragon activity',
  },
  EMERALD: {
    label: 'Emerald Dragon',
    economicEffect: 'Reduces food production',
  },
  SAPPHIRE: {
    label: 'Sapphire Dragon',
    economicEffect: 'Reduces rune production',
  },
  GOLD: {
    label: 'Gold Dragon',
    economicEffect: 'Reduces income',
  },
  RUBY: {
    label: 'Ruby Dragon',
    economicEffect: 'Effect TBD',
  },
};

const UNKNOWN_ANNOTATION: DragonAnnotation = {
  label: 'Unknown Dragon',
  economicEffect: 'Unknown effect',
};

/**
 * Returns the display annotation for a dragon type string.
 *
 * Returns a safe default for unknown types — no offense modifier is ever included.
 */
export function getDragonAnnotation(dragonType: string | null): DragonAnnotation {
  if (!dragonType) return DRAGON_ANNOTATIONS['NONE'];
  return DRAGON_ANNOTATIONS[dragonType] ?? UNKNOWN_ANNOTATION;
}
